import { api } from "@/lib/api/client"
import type { BaseResponse, IdOnly } from "@/types/api"
import type { OrderDetail, OrderListItem } from "@/types/domain"

export interface OrderWriteRequest {
  groupId: number
  agreedQuantity: number
  contractType?: string | null
  contractDurationStart?: string | null
  contractDurationEnd?: string | null
  dateOfExportToPort?: string | null
  qualityCriteria?: string | null
  deliveryAddress?: string | null
  orderNumber?: string | null
  agroforestryBonusPerKilo?: number | null
  basePrice?: number | null
}

export async function listOrders(limit?: number): Promise<OrderListItem[]> {
  const { data } = await api.get<BaseResponse<OrderListItem[]>>(
    "/exporter/orders",
    { params: limit ? { limit } : undefined },
  )
  if (!data.success) {
    throw new Error(data.message ?? "Could not load orders")
  }
  return data.result ?? []
}

export async function getOrder(orderId: string): Promise<OrderDetail> {
  const { data } = await api.get<BaseResponse<OrderDetail>>(
    `/exporter/orders/${orderId}`,
  )
  if (!data.success || !data.result) {
    throw new Error(data.message ?? "Could not load order")
  }
  return data.result
}

export async function createOrder(
  contractId: string,
  payload: OrderWriteRequest,
): Promise<IdOnly> {
  const { data } = await api.post<BaseResponse<IdOnly>>(
    `/exporter/contracts/${contractId}/orders`,
    payload,
  )
  if (!data.success || !data.result) {
    throw new Error(data.message ?? "Could not create order")
  }
  return data.result
}

export async function updateOrder(
  contractId: string,
  orderId: string,
  payload: OrderWriteRequest,
): Promise<IdOnly> {
  const { data } = await api.put<BaseResponse<IdOnly>>(
    `/exporter/contracts/${contractId}/orders/${orderId}`,
    payload,
  )
  if (!data.success || !data.result) {
    throw new Error(data.message ?? "Could not update order")
  }
  return data.result
}

export async function deleteOrder(
  contractId: string,
  orderId: string,
): Promise<void> {
  const { data } = await api.delete<BaseResponse>(
    `/exporter/contracts/${contractId}/orders/${orderId}`,
  )
  if (!data.success) {
    throw new Error(data.message ?? "Could not delete order")
  }
}
